import store from "../store";
import { CLEAR_HISTORY, GO_BACK, HISTORY, SET_HISTORY, SET_SELECTED_BUTTON } from "./types";


export const saveHistory = (history) => {
    const pathname = window.location.pathname
    const state = window.history.state?.state
    return {
        type: SET_HISTORY,
        payload: {item: {screenName:pathname,data:state},history}
    }
}
export const navigateTo = (screenName,data={}) => {
    const pathname = window.location.pathname
    const state = window.history.state?.state
    store.getState().nav.history.push(screenName, data);     
    return {
        type: HISTORY,
        payload: {screenName:pathname,data:state}
    }
}
export const goBack = () => {
    console.log(store.getState().nav.historyBack)
    console.log(store.getState().nav.historyBack?.slice(-1));  //cyan
    const item = [...store.getState().nav.historyBack]?.slice(-1)[0]
    if(!item) return
    const {screenName,data} = item
    store.getState().nav.history.push(screenName,data);
    return {
        type: GO_BACK,
        payload: {screenName,data}
    }
}
export const clearHistory = () => {
    return {
        type: CLEAR_HISTORY,
        
    }
}
export const setSelectedButton = (selected) => {
    return {
        type: SET_SELECTED_BUTTON,
        payload: selected 
        
    }
}
